import { Component, computed } from '@angular/core';
import { InitAllBoardListService } from '../../core/init-data/init-all-board-list.service';

@Component({
  selector: 'app-maintainance',
  standalone: true,
  imports: [],
  templateUrl: './maintainance.component.html',
  styleUrl: './maintainance.component.scss',
})
export class MaintainanceComponent {
  constructor(private initAllBoardListService: InitAllBoardListService) {}

  getContent = computed(() => {
    return this.initAllBoardListService.maintainanceText();
  });
}
